// extracted by mini-css-extract-plugin
export default {"heading":"LabeledSelect_heading__KoDjR","select":"LabeledSelect_select__qObEA"};